module.exports = __webpack_public_path__ + "img/drokov.c9ff589f.jpg";